import { MemberPersonTypes } from '../../domain/member';
import { GIS } from '../../domain/gis';
import { MemberDashboardLicenseResponseArray } from './member.dashboard.license.response';
import { NoteArray } from '../../domain/note';
import { TagArray } from '../../domain/tag';
import { MemberDashboardMembershipResponseArray } from './member.dashboard.membership.response';

export interface IMemberDashboard {
    ID: number;
    InfusionsoftID: number;
    Phone1: string;
    Phone2: string;
    Email: string;
    Fax: string;
    AccountSummary: number;
    FirstName: string;
    LastName: string;
    OpenTickets: number;
    IsDesigner: boolean;
    ParentID: number;
    ParentFirstName: string;
    ParentLastName: string;
    Company: string;
    InvoicesTotal: number;
    Credit: number;
    IsTOS: boolean;
    HasReviewed: boolean;
    IsLocked: boolean;
    MemberType: MemberPersonTypes;

    Address1: string;
    City: string;
    Zip: string;
    State: string;
    Country: string;

    GISTotals: GIS;
    OwnLicenses: MemberDashboardLicenseResponseArray;
    DesignersLicenses: MemberDashboardLicenseResponseArray;
    OrphanDesigners: MemberDashboardLicenseResponseArray;
    StickyNotes: NoteArray;
    AIActivitySummary: string;
    AIActivitySummaryUpdated: Date;
    Tags: TagArray;
    ExemptFromTax: boolean;    

    Balance: number;
    NotPaidInvoices: number;

    AuthorizedContactFirstName: string;
    AuthorizedContactLastName: string;
    AuthorizedContactEmail: string;
    AuthorizedContactNote: string;

    RecentCallSentiment: string;
    RecentCallSummary: string;
    CommonCallTopics: string;
    RecentCallTopics: string;

	HubspotVID: string;
	
	LocalDateTime: Date;
    TimeZoneCertainty: number;
}

export class MemberDashboard implements IMemberDashboard {
    ID: number;
    InfusionsoftID: number;
    Phone1: string;
    Phone2: string;
    Email: string;
    Fax: string;
    AccountSummary: number;
    FirstName: string;
    LastName: string;
    OpenTickets: number;
    IsDesigner: boolean;
    ParentID: number;
    ParentFirstName: string;
    ParentLastName: string;
    Company: string;
    InvoicesTotal: number;
    TaxPaid: number;
    ExemptFromTax: boolean;    
    Credit: number;
    IsTOS: boolean;
    IsFormerTOS: boolean;
    HasReviewed: boolean;
    IsLocked: boolean;
    MemberType: MemberPersonTypes;

    Address1: string;
    City: string;
    Zip: string;
    State: string;
    Country: string;

    GISTotals: GIS;
    OwnLicenses: MemberDashboardLicenseResponseArray;
    DesignersLicenses: MemberDashboardLicenseResponseArray;
    OrphanDesigners: MemberDashboardLicenseResponseArray;
    StickyNotes: NoteArray;
    AIActivitySummary: string;
    AIActivitySummaryUpdated: Date;
    Tags: TagArray;

    Memberships: MemberDashboardMembershipResponseArray;

    Balance: number;
    NotPaidInvoices: number;

    AuthorizedContactFirstName: string;
    AuthorizedContactLastName: string;
    AuthorizedContactEmail: string;
    AuthorizedContactNote: string;

    RecentCallSentiment: string;
    RecentCallSummary: string;
    CommonCallTopics: string;
    RecentCallTopics: string;

	HubspotVID: string;
	
	LocalDateTime: Date;
    TimeZoneCertainty: number;

    public static FixDates(item: MemberDashboard) {

		if( item.LocalDateTime != undefined )
			item.LocalDateTime = new Date(item.LocalDateTime);

		if( item.AIActivitySummaryUpdated != undefined )
			item.AIActivitySummaryUpdated = new Date(item.AIActivitySummaryUpdated);

        if (item.OwnLicenses != undefined && item.OwnLicenses.length > 0)
            MemberDashboardLicenseResponseArray.FixDates(item.OwnLicenses);

        if (item.DesignersLicenses != undefined && item.DesignersLicenses.length > 0)
            MemberDashboardLicenseResponseArray.FixDates(item.DesignersLicenses);

    }
}
